/**
 * Relative time formatter — accepts either a Unix epoch (seconds) or an ISO date string.
 * Returns a human-readable string like "Just now", "5m ago", "3h ago", "Yesterday", "4d ago",
 * or a formatted date for anything older than 7 days.
 */
// Pass `nowMs` from useNow() when rendering: a bare Date.now() here is cached by the React Compiler.
export function timeAgo(input, nowMs = Date.now()) {
  if (input == null || input === '') return '';
  let ms;
  if (typeof input === 'number') {
    ms = input * 1000;        // epoch seconds → ms
  } else if (typeof input === 'string' && /^\d+$/.test(input)) {
    ms = Number(input) * 1000; // BIGINT-as-string from n8n → epoch seconds → ms
  } else {
    ms = new Date(input).getTime();
  }
  if (!Number.isFinite(ms)) return '';
  const diff = nowMs - ms;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days}d ago`;
  return new Date(ms).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
